import { LineLayerSpecification, FillLayerSpecification } from 'mapbox-gl'

export const createDrawMaxBoundsLayerStyle = ({
  id,
}: {
  id: 'max-bounds-polygon'
}) => {
  const maxBoundsPolygon: FillLayerSpecification = {
    id: id,
    type: 'fill',
    source: null,
    filter: ['==', 'id', 'max-bounds-polygon'],
    paint: {
      'fill-color': '#FFA500',
      'fill-opacity': 0.2,
      'fill-outline-color': '#FFA500',
    },
  }

  const maxBoundsPolygonOutline: LineLayerSpecification = {
    id: `${id}-outline`,
    type: 'line',
    source: null,
    filter: ['==', 'id', 'max-bounds-polygon'],
    paint: {
      'line-color': '#FFA500',
      'line-width': 2,
    },
  }

  const maxBoundsPolygonGuide: FillLayerSpecification = {
    id: `${id}-guide`,
    type: 'fill',
    source: null,
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']],
    paint: {
      'fill-color': '#FFA500',
      'fill-opacity': 0.1,
      'fill-outline-color': '#FFA500',
    },
  }

  const maxBoundsPolygonGuideOutline: LineLayerSpecification = {
    id: `${id}-guide-outline`,
    type: 'line',
    source: null,
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']],
    paint: {
      'line-color': '#FFA500',
      'line-width': 2,
      'line-dasharray': [2, 2],
    },
  }

  return [
    maxBoundsPolygon,
    maxBoundsPolygonOutline,
    maxBoundsPolygonGuide,
    maxBoundsPolygonGuideOutline,
  ]
}
